export interface UserTeamInfo {
    teamName: string;
    testUser: boolean;
    activeSubscriptions: string[] | null;
}

export enum HomeTabs {
    HOME = "Home",
    DASHBOARD = "Dashboard",
}

export enum GiftDashboardFilters {
    BYDATE = "By Date",
    BYTYPE = "By Type",
    BYMEMBER = "By Member",
    NOFILTER = "No Filter",
}
